/* eslint-disable */

/** The cryptocurrencies supported by our network. */
export enum CryptoCurrency {
  /** UNKNOWN - Default is undefined and indicates a versioning error. */
  UNKNOWN = "UNKNOWN",
  BTC = "BTC",
  /** XUS - USDC is internally represented in Cash as XUS */
  XUS = "XUS",
}

/** A quantity of Bitcoin, internally denominated in satoshi, with a pico-btc remainder */
export interface BitcoinAmount {
  /** The base unit of account in satoshis (10^-8 Bitcoin, or 100m satoshi per Bitcoin */
  satoshi?: number;
  /** If necessary, any sub-satoshi remainder in pico btc (10^-12 Bitcoin, or 10k pico per satoshi) */
  remainder_pico?: number;
}

/** An amount of some cryptocurrency */
export interface CryptoAmount {
  /** The quantity of units (as defined by `scale`) of the currency */
  units?: number;
  /** A specific cryptocurrency */
  currency?: CryptoCurrency;
  /**
   * The count of decimal places to shift left on `units` in order to form a canonical denomination of `currency`.
   * e.g. For BTC:
   *   Bitcoin: 0
   *   MilliBtc: 4
   *   Satoshi: 8 (default)
   *   MilliSat: 11
   *   PicoBtc: 12
   */
  scale?: number;
}
